/** Allowed sample-point layouts for tile visibility tests. */
export const TILE_VISIBILITY_SAMPLE_DENSITIES = [1, 4, 5, 9] as const;

/**
 * Sample-point counts for tile visibility tests.
 * - 1: center only
 * - 4: four corners only
 * - 5: center + four corners
 * - 9: 3×3 grid (corners, edge midpoints, center)
 */
export type TileVisibilitySampleDensity = (typeof TILE_VISIBILITY_SAMPLE_DENSITIES)[number];

export function isTileVisibilitySampleDensity(value: unknown): value is TileVisibilitySampleDensity {
  return typeof value === 'number' && (TILE_VISIBILITY_SAMPLE_DENSITIES as readonly number[]).includes(value);
}
